import { render, staticRenderFns } from "./LearningGoalSelector.vue?vue&type=template&id=633dd608&"
import script from "./LearningGoalSelector.vue?vue&type=script&lang=js&"
export * from "./LearningGoalSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports